import React from "react";
import { withTranslation } from "react-i18next";
import { MasterFilterForm } from "../../../Form";

/**
 * MasterFilter component renders the filter form for the Master page.
 * It uses the MasterFilterForm component.
 * @component
 * @param {Object} props - Props for the component.
 * @param {Function} props.onSubmit - Function to handle form submission.
 * @param {Function} props.onReset - Function to handle form reset.
 * @param {Object} props.filterData - Data to pre-fill in the filter form.
 * @param {Array} props.arrayOfData - Array of data for dropdowns or selects.
 */
function MasterFilter({ onSubmit, onReset, filterData, arrayOfData }) {
  return (
    <MasterFilterForm
      arrayOfData={arrayOfData}
      onSubmit={onSubmit}
      filterData={filterData}
      onReset={onReset}
    />
  );
}

export default withTranslation()(MasterFilter);
